export const dataTableRowLayoutHeight = (element: HTMLElement) => element.offsetHeight;
